@if (warnings.length > 0) {
	<section class="rea-section rea-section--warning">
		<h4>Avisos importantes</h4>

		<ul class="rea-list">
			@for (warning of warnings; track warning) {
				<li>
					<i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
					<span>{{ warning }}</span>
				</li>
			}
		</ul>
	</section>
}
